import { useEffect, useState } from 'react';

import { DatePicker } from '@trackman/web-shared-components';

export const AppDatePicker = ({ label, value, disabled, required, errorMessage, hint = '', onChange }) => {
  const [selectedDate, setSelectedDate] = useState<Date | null>(value);
  const [isTouched, setIsTouchedState] = useState<boolean>(false);

  useEffect(() => {
    onChange(selectedDate);
  }, [selectedDate]);

  const onChangeDateHandler = (date: Date | null) => {
    setIsTouchedState(true);

    if (!date) {
      setSelectedDate(null);
      return;
    }
    const newDate = new Date(date);
    const year = newDate?.getFullYear();
    const month = newDate?.getMonth();
    const day = newDate?.getDate();

    if (newDate && year && month && day) {
      const dateInUtc = new Date(Date.UTC(year, month, day));
      const dateInIso = dateInUtc?.toISOString();
      setSelectedDate(dateInIso as unknown as Date);
      return;
    }

    setSelectedDate(date);
  };

  return (
    <div className='add-date-picker'>
      <DatePicker
        inputFormat='DD/MM/YYYY'
        mask='__/__/____'
        label={label}
        value={selectedDate}
        disableFuture
        error={!selectedDate || !new Date(selectedDate)?.getFullYear()}
        onChange={(date: Date | null) => {
          console.log('🚀 ~ file: AppDatePicker.tsx:58 ~ AppDatePicker ~ date:', date);

          onChangeDateHandler(date);
        }}
        disabled={disabled}
      />
      {required && (!selectedDate || !new Date(selectedDate)?.getFullYear()) && isTouched ? (
        <p className={`font-11 font-lato text-capitalize mb-0 color-danger`}>{errorMessage}</p>
      ) : (
        <p className={`font-11 font-lato text-capitalize mb-0 color-secondaryGrey`}>{hint}</p>
      )}
    </div>
  );
};

export default AppDatePicker;
